import CommonActionModal from "../Common/CommonActionModal";
import MaterialSearch from "./MaterialSearch";

// icons
import SearchIcon from "@mui/icons-material/Search";


class MaterialSearchModal extends CommonActionModal {
    async setModalOpenFalse() {
        if (this.props.callBack){
            await this.props.callBack();
        }
        this.setState(
            {
                modalOpen: false,
            }
        );
    }

    componentDidMount(){
        this.setState({
            button:{
                icon: SearchIcon,
                label: 'Поиск'
            },
            modalLabel: 'Поиск по материалам',
            modalIcon: SearchIcon,
            mainComponent: MaterialSearch,
            mainComponentProps: {},
            ready: true,
        })
    }
}

export default MaterialSearchModal
